export enum EProfilingRequestSource {
  portalIntegration = 'PortalIntegration',
  contract = 'Contract',
  onboardingRetail = 'Onboarding Retail',
  clickAndGo = 'Click&Go',
  onboarding = 'Onboarding',
  onboardingContract = 'Onboarding Contract',
  onboardingBPRegistration = 'Onboarding BPRegistration',
  dialer = 'Dialer',
}

export enum EProfilingWorkflowStatus {
  draft = 'Draft',
  new = 'New',
  wip = 'WIP',
  done = 'Done',
  rejected = 'Rejected',
}
